import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

const herosectionData = {
  name: "Erandi Suli",
  aboutMe:
    "A highly motivated IT professional with a passion for technology and a proven track record in back-end web development, system administration, and networking.  Eager to leverage technical skills and problem-solving abilities to contribute to a dynamic team.",
};

function Herosection() {
  return (
    <section
      className="hero background parallax shadow-dark d-flex align-items-center"
      style={{ backgroundImage: "url(/images/HeroImage.png)" }}
    >
      <div className="cta mx-auto mt-2">
        <h1 className="mt-0 mb-4">
          I’m {herosectionData.name}
          <span className="dot"></span>
        </h1>
        <p className="mb-4">{herosectionData.aboutMe}</p>
        <Link
          activeclass="active"
          to="/works"
          className="btn btn-default btn-lg mr-3"
        >
          <i className="icon-grid"></i>View Portfolio
        </Link>
        <div
          className="spacer d-md-none d-lg-none d-sm-none"
          data-height="10"
        ></div>
        <Link
          activeclass="active"
          to="/contact"
          className="btn btn-border-light btn-lg"
        >
          <i className="icon-envelope"></i>Hire me
        </Link>
      </div>
      <div className="overlay"></div>
    </section>
  );
}

export default Herosection;
